export class ReactionCountModel {
    _id: string | undefined;
    count: number | undefined;
    sourceId: string | undefined;
    sourceType: string | undefined;
    reactionCounts?: { [reactionType: string]: number };
}